module.exports = "/assets/data/9ce4e62a4a3d412462c1cf5dd1161b99-GL20.data.json";